import axios from "../axios/index.js";

const urlGetListImage = "/api/gallery/get-list";
const urlCreateGallery = "/api/gallery/create";
const urlDeleteGallery = "/api/gallery/delete";

export default {
    getList(params) {
        return axios.get(urlGetListImage, { 
            params: params
        });
    },

    create(params) {
        return axios.post(urlCreateGallery, params);
    },

    delete(params) {
        return axios.post(urlDeleteGallery, params);
    },
};
